import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { Card, CardContent, InputAdornment } from '@mui/material'
import { Email } from '@mui/icons-material'
import { useForm } from '../../common/utils/form-generation/useForm'
import { LoginButton } from './components/Button'
import { LoginTextField } from './components/TextField'
import { URL_LOGIN } from '../../routes/routes-constants'
import { useStyles } from './Login.styles'
import { Alert } from '@mui/material'
import { getAuthContainer } from '../../container/auth-modules'
import { AuthService } from '../../modules/auth/services/AuthService'
import { AUTH_SERVICE_KEY } from '../../modules/auth'

const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)

function SuccessForm(props: {
  isSuccess: boolean
  onBack: (success: boolean | undefined) => void
}) {
  const { t } = useTranslation()
  const classes = useStyles()

  const goBack = () => {
    props.onBack && props.onBack(undefined)
  }

  return (
    <>
      {(props.isSuccess && (
        <Container>
          <Alert severity={'info'}>{t('youWillReceiveAnEmailToResetPassword')}</Alert>
        </Container>
      )) || (
        <Container>
          <Alert severity={'error'}>{t('canNotResetPassword')}</Alert>
          <LoginButton
            onClick={() => goBack()}
            fullWidth
            variant={'contained'}
            color={'primary'}
            className={classes.loginButton}>
            {t('back')}
          </LoginButton>
        </Container>
      )}
    </>
  )
}

function RecoverPasswordForm(props: { onSubmit: (data: { email: string }) => void }) {
  const classes = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoLogin = () => navigate(URL_LOGIN)

  const { handleSubmit, handleChange, data, errors } = useForm<{ email: string }>({
    validations: {
      email: {
        pattern: {
          value: '^[^\\s@]+@[^\\s@]+$',
          message: t('E-mail no válido'),
        },
      },
    },

    onSubmit: () => {
      props.onSubmit && props.onSubmit(data)
    },
  })

  return (
    <Container className={classes.containerForm}>
      <Typography align={'left'} component={'h1'} variant={'h5'}>
        {t('recoverPassword')}
      </Typography>

      <form className={classes.form} autoComplete={'off'} onSubmit={handleSubmit}>
        <LoginTextField
          variant={'filled'}
          margin={'normal'}
          required
          fullWidth
          id={'email'}
          onChange={(event) => handleChange('email', event.target.value)}
          placeholder={t('Email')}
          name={'email'}
          InputProps={{
            startAdornment: (
              <InputAdornment color={'inherit'} position={'start'}>
                <Email color={'inherit'} />
              </InputAdornment>
            ),
          }}
          autoComplete={'off'}
        />
        {errors.email && <p className={'error'}>{errors.email}</p>}
        <Grid container alignItems={'center'} justifyContent={'space-between'}>
          <Grid item xs={3}>
            <LoginButton
              type={'submit'}
              fullWidth
              variant={'contained'}
              color={'primary'}
              className={classes.loginButton}>
              {t('remember')}
            </LoginButton>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.link} onClick={() => handleGoLogin()} align={'right'}>
              {t('goToLogin')}
            </Typography>
          </Grid>
        </Grid>
      </form>
    </Container>
  )
}

export const RecoverPassword = () => {
  const classes = useStyles()
  const [success, setSuccess] = useState<boolean | undefined>()

  const sendEmail = (data: { email: string }) => {
    authService.recoverPassword({ email: data.email }).subscribe((res: boolean) => {
      if (res) {
        setSuccess(true)
      } else {
        setSuccess(false)
      }
    })
  }

  return (
    <Container className={classes.container}>
      <Grid container className={classes.root} spacing={0} alignItems="center" justifyContent="center">
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Grid alignItems="stretch" container spacing={0}>
              <Grid item xs={12} className={classes.innerGrid}>
                {(success !== undefined && (
                  <SuccessForm isSuccess={success} onBack={(success) => setSuccess(success)} />
                )) || <RecoverPasswordForm onSubmit={(data) => sendEmail(data)} />}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Container>
  )
}
